import React from 'react';
import type { AdminCommunicationPayload } from '../../../../types/admin';
import { TYPE_CONFIG } from './communicationsConfig';

interface Props {
  payload: Partial<AdminCommunicationPayload>;
}

const NotificationPreview: React.FC<Props> = ({ payload }) => {
  const typeConf = TYPE_CONFIG[payload.type ?? 'info'];
  const hasContent = payload.title || payload.message;

  return (
    <div className="ac-preview">
      <p className="ac-preview__label">
        <i className="bi bi-eye me-2" />
        Anteprima notifica
      </p>
      <div className={`ac-preview__card ${typeConf.className}`}>
        {!hasContent ? (
          <p className="ac-preview__empty">
            Compila il titolo e il messaggio per vedere l'anteprima.
          </p>
        ) : (
          <>
            <div className="ac-preview__header">
              <i className={`bi ${typeConf.icon} ac-preview__icon`} />
              <span className="ac-preview__title">
                {payload.title || 'Titolo notifica'}
              </span>
            </div>
            <p className="ac-preview__message">
              {payload.message || 'Testo del messaggio…'}
            </p>
            {payload.actionLabel && payload.actionUrl && (
              <span className="ac-preview__action">
                {payload.actionLabel} →
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default NotificationPreview;
